const resetFiltersOnSetLocality = (filters, keepMapFilters = false) => {
  const newFilters = { ...filters, nearby: null };
  const mapFilters = ['geobounds', 'geocircle', 'geopolygon', 'precision'];
  if (!keepMapFilters) {
    mapFilters.forEach(
      (filter) => {
        if (filter in newFilters) {
          delete newFilters[filter];
        }
      },
    );
  } else {
    mapFilters.forEach(
      (filter) => {
        if (filter in newFilters && newFilters[filter] === null) {
          delete newFilters[filter];
        }
      },
    );
  }

  return newFilters;
};

export default resetFiltersOnSetLocality;
